<template>
  <div class="user">
    <h1 class="P1" style="text-align: center">
      <a id="a__会员服务协议"><span /></a>会员服务协议
    </h1>
    <p class="P4_borderStart" />
    <p class="P5">
      <span class="T2"
        >本会员服务协议是您与上海丙晟科技有限公司（本协议中简称“丙晟科技”或“我们”）之间的法律协议。上海丙晟科技有限公司根据以下服务条款为您提供服务。</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >（1）请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。请您仔细阅读本协议，您勾选"同意"后，即视为您同意、接受并订立本协议约定条款。您勾选“同意”后，即表示您亦同意成为丙晟科技【万达广场鸿蒙原子化服务】的会员。</span
      >
    </p>
    <div class="P5">
      <span class="T2"
        >（2）如您访问或使用【万达广场鸿蒙原子化服务】提供基于互联网、移动互联网信息服务及相应软件技术服务（包括但不限于</span
      ><span></span><span class="T2">网上商城、使用WIFI接入、停车服务</span
      ><span class="T2"
        >等）的载体，，包括但不限于：丙晟相关微信公众号、小程序产品、网站等载体，或您通过其它方式使用丙晟科技提供的服务（下称"服务"），即视为您同意、接受并订立本协议约定条款。</span
      >
    </div>
    <p class="P5_borderEnd">
      <span class="T2"
        >丙晟科技的各项服务的所有权和运作权归丙晟科技所有。当您使用服务时，如丙晟科技公布了与该服务相关其他指引和规则，则前述所有的指引和规则，均构成本协议的一部分。您应于使用服务前认真阅读全部协议内容。如您不同意本协议及/或随时对其的修改，我们有权限制您使用部分或全部的服务同时请您立即停止使用服务；一旦您使用服务，即视为您已了解并完全同意本协议各项内容。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__一、服务说明"><span /></a>一、服务说明
    </h2>
    <p class="P5">
      <span class="T3"
        >会员了解并同意，丙晟科技可向会员提供的服务可能受当时技术、资源和权利条件所限而有所变化，具体服务内容以及相应价格和条件应以丙晟科技实际提供时为准。丙晟科技有权为维修保养、功能升级、安全、公共利益或基于其它合理事由暂停服务的全部或任何部分，丙晟科技将尽可能提前通知您服务暂停的情况，但您理解，由于紧急情况或突发事件，我们可能无法提前通知，但我们将在可行的情况下立即告知服务暂停的情况并予以说明。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__二、遵守法律"><span /></a>二、遵守法律
    </h2>
    <p class="P5_borderStart">
      <span class="T3"
        >会员同意遵守中华人民共和国相关法律法规的所有规定，并对以任何方式使用会员的密码和会员的账号使用服务的任何行为及其结果承担全部责任。</span
      ><span class="T2"
        >如会员的行为违反国家法律和法规的任何规定，有可能构成犯罪的，将被追究刑事责任，并由会员承担全部法律责任。</span
      >
    </p>
    <p class="P5">
      <span class="T3"
        >同时如果丙晟科技有理由认为会员的任何行为，包括但不限于会员的任何言论和其它行为违反或可能违反国家法律和法规的任何规定，或我们发现或收到他人举报或投诉会员违反本协议约定的，丙晟科技有权不经通知随时对相关内容进行删除、屏蔽，并可视具体情况采取对应措施，该等措施包括但不限于警告、提示会员更正不当行为、限制或禁止相关服务功能或账号封禁、暂停向会员提供服务等。</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >丙晟科技和您有义务遵从国家发布的有关实名认证的法律法规和政策，包括但不限于如下规定：</span
      >
    </p>
    <p class="P5">
      <span class="T2">
        1、《中华人民共和国网络安全法》，第二十四条网络运营者为用户办理网络接入、域名注册服务，办理固定电话、移动电话等入网手续，或者为用户提供信息发布、即时通讯等服务，在与用户签订协议或者确认提供服务时，应当要求用户提供真实身份信息。用户不提供真实身份信息的，网络运营者不得为其提供相关服务。</span
      >
    </p>
    <p class="P5">
      <span class="T2">
        2、《中华人民共和国反恐怖主义法》要求,
        第二十一条电信、互联网、金融、住宿、长途客运、机动车租赁等业务经营者、服务提供者，应当对客户身份进行查验。对身份不明或者拒绝身份查验的，不得提供服务。
      </span>
    </p>
    <p class="P5">
      <span class="T2"> </span
      ><span class="T3">
        请您理解，如您未按国家相关法律法规要求在丙晟科技提供服务的任何界面进行实名认证，丙晟科技将有权根据自行判断采取如下措施，且无需承担任何责任：</span
      >
    </p>
    <p class="P5">
      <span class="T3"> 1）部分直至全部限制您注册使用服务；</span>
    </p>
    <p class="P5">
      <span class="T3"> 2）部分直至全部限制您申请签署服务协议和订单；</span>
    </p>
    <p class="P5">
      <span class="T3"> 3）部分直至全部限制您购买丙晟科技的产品和服务；</span>
    </p>
    <p class="P5">
      <span class="T3">
        4）部分直至全部限制您启动、停止、修改、删除已有服务资源；以及</span
      >
    </p>
    <p class="P5">
      <span class="T3"> 5）其它依据法律法规要求应当采取的措施。</span>
    </p>
    <p class="P5_borderEnd">
      <span class="T3"
        >为了有效对您进行实名认证，您同意我们可以在必要范围内与第三方进行信息核对。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__三、会员的注册义务"><span /></a>三、会员的注册义务
    </h2>
    <p class="P5_borderStart">
      <span class="T2"
        >1）会员同意本协议条款并完成注册程序，才能成为【万达广场鸿蒙原子化服务】的会员。</span
      >
    </p>
    <p class="P5">
      <span class="T3"
        >2）会员点击同意本协议的，即视为会员确认自己具有享受丙晟科技相关服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。</span
      >
    </p>
    <p class="P5">
      <span class="T3"
        >3）会员应依服务注册提示填写正确的注册信息，并确保今后更新的资料的有效性和合法性。若会员提供任何违法、不道德或丙晟科技认为不适合展示的资料；或者丙晟科技有理由怀疑会员的资料属于程序或恶意操作，丙晟科技有权限制、暂停或终止会员的账号，并拒绝会员于现在和未来使用服务之全部或任何部分。</span
      >
    </p>
    <p class="P5_borderEnd">
      <span class="T3"
        >尽管如此，丙晟科技无须对任何会员的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、正确性、完整性、适用性及/或是否为最新资料的责任。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__四、注册账号、密码及安全"><span /></a>四、注册账号、密码及安全
    </h2>
    <p class="P5_borderStart">
      <span class="T3"
        >完成服务的注册程序并成功注册之后，会员可登录到会员在丙晟科技注册的账号（下称"账号"）。会员账号的所有权由丙晟科技所有，会员完成申请注册手续后，仅获得账号的使用权，且该使用权仅属于初始申请注册人。保护会员的账号安全，是会员的责任。会员应对所有使用会员的密码及账号的活动负完全的责任。会员同意：</span
      >
    </p>
    <p class="P5">
      <span class="T3"
        >1）在任何情况下不向他人透露账户及密码信息。会员获知其在丙晟科技注册的账号遭到未获授权的使用，或者发生其它任何安全问题时，会员将立即通知丙晟科技；</span
      >
    </p>
    <p class="P5">
      <span class="T3"
        >2）当会员登录互联网时，您应完全自行负责采取或实施您认为合适的安全手段保护您的隐私或个人信息及财产。对于您的隐私或个人信息及财产因您使用无线上网服务而发生的损失、破坏或遭非法侵入或使用，如果会员未保管好自己的账号和密码，因此而产生的任何损失或损害，丙晟科技无法也不承担任何责任；</span
      >
    </p>
    <p class="P5_borderEnd">
      <span class="T3"
        >3）每个会员都要对其账号中的所有行为和事件负全责。如果会员未保管好自己的账号和密码而对会员、丙晟科技或第三方造成的损害，会员将负全部责任。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__五、个人信息保护"><span /></a>五、个人信息保护
    </h2>
    <p class="P5_borderStart">
      <span class="T2"
        >1、保护会员个人信息是丙晟科技的一项基本原则。丙晟科技将会依法采取合理的措施保护会员的个人信息。丙晟科技对相关信息采用专业加密存储与传输方式，保障会员个人信息的安全。除非有法律许可要求或为法定目的或根据司法或其它政府部门的指令或要求就披露该等会员个人信息提供协助或丙晟科技在诚信的基础上认为透露这些信息在以下情况是必要的，未经会员许可丙晟科技不会向第三方公开、透露会员个人信息：</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >(1)遵守有关法律规定，遵从【万达广场鸿蒙原子化服务】隐私政策；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >(2)在紧急情况下竭力维护会员个人和社会大众的安全利益；</span
      >
    </p>
    <p class="P5"><span class="T2">(3)符合其他法定要求。</span></p>
    <p class="P5">
      <span class="T2"
        >2、会员在注册账号或使用服务的过程中，需要提供一些必要的信息，例如：为向会员提供账号注册服务或进行会员身份识别，需要会员填写手机号码；为向会员提供准确的服务信息，需要会员同意使用会员所在的地里位置信息等。若国家法律法规或政策有特殊规定的，会员需要提供真实的身份信息。若会员提供的信息不完整，则无法使用相关服务或在使用过程中受到限制。</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >3、一般情况下，会员可随时浏览、修改自己提交的个人信息，但是出于安全性和身份识别（如号码申诉服务）的考虑，会员可能无法修改注册时</span
      ><a id="_GoBack" /><span class="T2"
        >提供的初始注册信息及其他验证信息。</span
      >
    </p>
    <p class="P5">
      <span class="T3"
        >4、如果会员停止使用服务或服务被终止或取消，我们可以从服务器上永久地删除会员的账号及数据。服务停止、终止或取消后，会员同意丙晟科技无需向会员返还任何数据。</span
      >
    </p>
    <p class="P5_borderEnd">
      <span class="T3"
        >5、对于我们如何收集、使用、存储和保护会员的个人信息及会员享有何种权利，会员还可以阅读【万达广场鸿蒙原子化服务】《隐私政策》予以进一步了解。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__六、提供者之责任"><span /></a>六、提供者之责任
    </h2>
    <p class="P5">
      <span class="T2"
        >根据有关法律法规，丙晟科技在此郑重提请会员注意，任何经由服务而发布、上传的文字、图像或其它资料（以下简称"内容"），无论系公开还是私下传送，均由内容提供者承担责任。丙晟科技仅为会员提供内容存储空间，无法控制经由服务传送之内容，因此不保证内容的正确性、完整性或品质。在任何情况下，丙晟科技均不为任何内容负责，但丙晟科技有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停会员使用服务的全部或部分，保存有关记录，并向有关机关报告。会员可能会使用服务进入非丙晟科技控制和/或维护的网站（简称"第三方网站"）。丙晟科技对于任何第三方网站的内容、准确性、及时性或数据传送，以及第三方网站上包含的任何观点、意见、表述、信息、服务、图片、音频或视频文件或任何其它的数据或信息，均不承担任何责任。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__七、会员行为"><span /></a>七、会员行为
    </h2>
    <p class="P5_borderStart">
      <span class="T2"
        >会员同意将不会利用服务进行任何违法或不正当的活动，包括但不限于下列行为∶</span
      >
    </p>
    <p class="P5">
      <span class="T2">1）发布或以其它方式传送含有下列内容之一的信息：</span>
    </p>
    <p class="P5"><span class="T2">a)反对宪法所确定的基本原则的；</span></p>
    <p class="P5">
      <span class="T2"
        >b)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span
      >
    </p>
    <p class="P5"><span class="T2">c)损害国家荣誉和利益的；</span></p>
    <p class="P5">
      <span class="T2">d)煽动民族仇恨、民族歧视、破坏民族团结的； </span>
    </p>
    <p class="P5">
      <span class="T2">e)破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
    </p>
    <p class="P5">
      <span class="T2">f)散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
    </p>
    <p class="P5">
      <span class="T2"
        >g)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span
      >
    </p>
    <p class="P5">
      <span class="T2">h)侮辱或者诽谤他人，侵害他人合法权利的；</span>
    </p>
    <p class="P5">
      <span class="T2"
        >i)含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >j)含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</span
      >
    </p>
    <p class="P5">
      <span class="T2">k)含有丙晟科技认为不适合在丙晟科技展示的内容。</span>
    </p>
    <p class="P5"><span class="T2">2）以任何方式危害他人的合法权益；</span></p>
    <p class="P5">
      <span class="T2"
        >3）冒充其他任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >4）将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以发布、发送电子邮件或以其它方式传送；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >5）将侵害他人著作权、专利权、商标权、商业秘密、或其它专属权利（以下简称"专属权利"）之内容加以发布或以其它方式传送；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >6）将任何广告信函、促销资料、"垃圾邮件"、"滥发信件"、"连锁信件"、"直销"或其它任何形式的劝诱资料加以发布、发送或以其它方式传送；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >7）将设计目的在于干扰、破坏或限制任何计算机软件、硬件或通讯设备功能之计算机病毒（包括但不限于木马程序（trojanhorses）、蠕虫（worms）、定时炸弹、删除蝇（cancelbots）（以下简称"病毒"）或其它计算机代码、档案和程序之任何资料，加以发布、发送或以其它方式传送；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >8）干扰或破坏服务或与服务相连线之服务器和网络，或违反任何关于服务连线网络之规定、程序、政策或规范；</span
      >
    </p>
    <p class="P5">
      <span class="T2">9）跟踪、人肉搜索或以其它方式骚扰他人；</span>
    </p>
    <p class="P5">
      <span class="T2"
        >10）故意或非故意地违反任何适用的当地、国家法律，以及任何具有法律效力的规则；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >11）未经合法授权而截获、篡改、收集、储存或删除他人个人信息、站内邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的。</span
      ><span class="T3"
        >会员已认可丙晟科技未对会员的使用行为进行全面控制，会员使用任何内容时，包括依赖前述内容之正确性、完整性或实用性时，会员同意将自行加以判断并承担所有风险，而不依赖于丙晟科技。但丙晟科技依其自行之考虑，拒绝和删除可经由服务提供之违反本条款的或其它引起丙晟科技反感的任何内容。会员了解并同意，丙晟科技依据法律法规的要求，或基于诚信为了以下目的或在合理必要范围内，认定必须将内容加以保存或揭露时，得加以保存或揭露：</span
      >
    </p>
    <p class="P5"><span class="T3">a）遵守法律程序；</span></p>
    <p class="P5"><span class="T3">b）执行本协议；</span></p>
    <p class="P5"><span class="T3">c）回应任何第三人提出的权利主张；</span></p>
    <p class="P5">
      <span class="T3"
        >d）保护丙晟科技、其会员及公众之权利、财产或个人安全；</span
      >
    </p>
    <p class="P5"><span class="T3">e）其它丙晟科技认为有必要的情况。</span></p>
    <p class="P5_borderEnd">
      <span class="T2"
        >12）会员承诺不利用丙晟科技提供的任何服务从事任何收费或盈利行为。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__八、国际使用之特别警告"><span /></a>八、国际使用之特别警告
    </h2>
    <p class="P5">
      <span class="T3"
        >会员已了解国际互联网的无国界性，同意遵守当地所有关于网上行为及内容之法律法规。会员特别同意遵守有关从中国或会员所在国家或地区输出信息之传输的所有适用法律法规。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__九、未成年人"><span /></a>九、未成年人
    </h2>
    <p class="P5">
      <span class="T3"
        >未成年人（指18周岁以下），在未取得您家长或监护人书面同意前不得使用服务，请您立即停止注册行为，并不要提供任何个人信息。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__十、会员发布的公开信息"><span /></a>十、会员发布的公开信息
    </h2>
    <p class="P5_borderStart">
      <span class="T2"
        >1）会员了解并同意，会员通过丙晟科技服务发布的公开信息可能被全世界范围内可以接受丙晟科技服务的其他会员所获取；</span
      >
    </p>
    <div class="P5_borderEnd">
      <span class="T2"
        >2）就会员在丙晟科技上传或发布的内容，会员应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益，</span
      ><span class="T2"
        >会员同意授予丙晟科技所有上述内容在全球范围内的免费、不可撤销的、永久的、可再许可独家使用权许可，据该许可丙晟科技将有权以复制、广播、汇编、网络传播及其他不为法律所禁止的方式使用前述内容。</span
      >
    </div>
    <h2 class="Heading_20_2">
      <a id="a__十一、赔偿"><span /></a>十一、赔偿
    </h2>
    <p class="P5_borderStart">
      <span class="T3"
        >（1）任何使用服务的会员应当为丙晟科技及其关联企业辩护、赔偿服务门店及其关联企业，使服务门店及其关联企业免于因任何下述事项遭受任何和所有的索赔、要求、诉讼、责任、成本或损害：</span
      >
    </p>
    <p class="P5"><span class="T3">(a)会员使用服务的行为;</span></p>
    <p class="P5">
      <span class="T3"
        >(b)会员通过服务提交、发布、传送或以其他方式展示任何内容;</span
      >
    </p>
    <p class="P5"><span class="T3">(c)会员任何违反本条款的行为；</span></p>
    <p class="P5">
      <span class="T3">(d)会员侵犯第三方的任何权利的行为。</span>
    </p>
    <p class="P5">
      <span class="T3"
        >在任何上述情形下，会员赔偿丙晟科技及其关联企业的范围应当包括丙晟科技及其关联企业因任何本条款项下的诉讼或索赔、或在主张本条款效力的过程中承担的合理的律师和专家证人的费用和开支。</span
      >
    </p>
    <p class="P5"><span class="T2">（2）免责声明和责任限制</span></p>
    <p class="P5">
      <span class="T3"
        >除非另有明确说明，服务系基于其现状而提供的，不附带任何明示或暗示的保证,包括但不限于对服务的可适用性，没有错误或疏漏，持续性，准确性，可靠性，适用于某一特定用途之类的保证，声明或承诺。丙晟科技对服务所涉的技术和信息的有效性，准确性，正确性，可靠性，质量，稳定，完整和及时性均不作承诺和保证。使用服务下载或者获取任何资料的行为均出于会员的独立判断并自行承担风险。每一个会员独自承担因此对其电脑系统或资料灭失造成的损失。</span
      >
    </p>
    <p class="P5">
      <span class="T3"
        >不论在何种情况下，丙晟科技均不对由于Internet连接故障，电脑，通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，不可抗力，战争，政府行为，国际、国内法院的命令或第三方的不作为而造成的不能服务或延迟服务承担责任。</span
      >
    </p>
    <p class="P5_borderEnd">
      <span class="T3"
        >在任何情况下，对于因使用服务导致的任何直接或间接损害、或者与使用服务有关的任何索赔（包括但不限于，通过服务而导致的任何种类的损失或损害，即便丙晟科技知晓有发生该等损失或损害的可能），丙晟科技或其关联企业、或其各自的董事、管理人员、雇员、代理人、承包商、供应商、运营商或许可方（合称"丙晟科技关联人士"）均不承担任何责任。若本条所述的责任限制被任何适用的法律视作无效，则丙晟科技及各丙晟关联人士的责任应在法律允许的限度内得到最大程度的限制。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__十二、关于使用及储存之一般措施"><span /></a
      >十二、关于使用及储存之一般措施
    </h2>
    <p class="P5_borderStart">
      <span class="T3"
        >会员同意不对服务任何部分或服务所使用或获得的内容，进行复制、拷贝、出售、转售或用于任何其它商业目的。</span
      >
    </p>
    <p class="P5_borderEnd">
      <span class="T3"
        >会员承认关于服务的使用，丙晟科技有权制订一般措施及限制，包含但不限于服务将保留所发布内容或其它发布内容之最长期间，以及一定期间内会员使用服务之次数上限（及每次使用时间之上限）。通过服务发布或传送之任何信息、通讯资料和其它内容，如被删除或未予储存，会员同意丙晟科技无需承担任何责任。会员也同意，丙晟科技有权依其自行之考虑，不论通知与否，随时变更这些一般措施及限制。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__十三、服务之修改"><span /></a>十三、服务之修改
    </h2>
    <p class="P5">
      <span class="T3"
        >丙晟科技有权于任何时间暂时或永久修改或终止服务（或其任何部分），且无论通知与否。会员同意对于服务所作的任何修改、暂停或终止，丙晟科技对会员和任何第三人均无需承担任何责任。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__十四、终止服务"><span /></a>十四、终止服务
    </h2>
    <p class="P5">
      <span class="T3"
        >会员同意丙晟科技基于其自行之考虑，因任何理由，包含但不限于缺乏使用，或丙晟科技认为会员已经违反本协议的文字及精神，终止会员的账号或服务之使用（或服务之任何部分）或取消，并将会员在服务内任何内容加以移除并删除，会员同意依本协议任何规定提供之服务，无需进行事先通知即可中断或终止，会员承认并同意，丙晟科技可立即关闭或删除会员的账号及会员账号中所有相关信息及文件，及/或禁止继续使用前述文件或服务。此外，会员同意若服务之使用被中断或终止或会员的账号及相关信息和文件被关闭或删除，或被取消，丙晟科技对会员或任何第三人均不承担任何责任。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__十五、与广告商及其他第三方进行交易"><span /></a
      >十五、与广告商及其他第三方进行交易
    </h2>
    <p class="P5">
      <span class="T2"
        >会员通过丙晟科技任何服务平台（载体）与广告商及其他第三方进行任何形式的通讯或商业往来，或参与促销活动，包含相关商品或服务之付款及交付，以及达成的其它任何相关条款、条件、保证或声明，完全为会员与广告商及其他第三方之间之行为。</span
      ><span class="T3"
        >会员因前述任何交易或前述广告商及其他第三方而遭受的任何性质的损失或损害，丙晟科技对此不负任何法律责任。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__十六、上海丙晟科技有限公司之专属权利"><span /></a
      >十六、上海丙晟科技有限公司之专属权利
    </h2>
    <p class="P5">
      <span class="T3"
        >会员了解并同意，服务及服务所使用之相关软件（以下简称"软件"）含有受到相关知识产权及其它法律保护之专有保密资料。会员也了解并同意，经由服务或广告商向会员呈现之赞助广告或信息所包含之内容，亦受到著作权、商标权、服务商标、专利权或其它专属权利之法律保护。未经丙晟科技或广告商明示授权，会员不得修改、出租、出借、出售、散布服务或软件之任何部份或全部，或据以制作衍生著作，或使用擅自修改后的软件，包括但不限于为了未经授权而使用服务之目的。丙晟科技仅授予会员个人、不可移转及非专属之使用权，使会员得于单机计算机或手机终端使用其软件之目的码，但会员不得（并不得允许任何第三人）复制、修改、创作衍生著作、进行还原工程、反编译，或以其它方式发现源代码，或出售、转让、再授权或提供软件设定担保，或以其它方式移转软件之任何权利。会员同意将通过由丙晟科技所提供的界面而非任何其它途径使用服务。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__十七、担保与保证"><span /></a>十七、担保与保证
    </h2>
    <p class="P5_borderStart"><span class="T2">会员明确了解并同意：</span></p>
    <p class="P5">
      <span class="T3"
        >1）会员使用服务之风险由会员个人负担，但不免除因丙晟科技的故意和重大过失对会员造成人身损害时的赔偿责任。服务系依服务的现状及现有条件提供。丙晟科技对服务不提供任何明示或默示的担保或保证，包含但不限于商业适售性、特定目的之适用性及未侵害他人权利等担保或保证；</span
      >
    </p>
    <p class="P5"><span class="T3">2）丙晟科技不保证以下事项：</span></p>
    <p class="P5"><span class="T3">a）服务将符合会员的要求；</span></p>
    <p class="P5">
      <span class="T3">b）服务将不受干扰、及时提供、安全可靠或不会出错；</span>
    </p>
    <p class="P5"><span class="T3">c）使用服务取得之结果正确可靠；</span></p>
    <p class="P5">
      <span class="T3"
        >d）会员经由服务购买或取得之任何产品、服务、资讯或其它信息将符合会员的期望；</span
      >
    </p>
    <p class="P5">
      <span class="T3"
        >3）是否使用服务下载或取得任何资料应由会员自行考虑且自负风险，因任何资料之下载而导致的会员电脑系统之任何损坏或数据流失等后果，由会员自行承担，但因丙晟科技故意或重大过失导致的除外；</span
      >
    </p>
    <p class="P5_borderEnd">
      <span class="T3"
        >4）会员自丙晟科技或经由服务取得的任何建议或信息，无论是书面或口头形式，除非本协议有明确规定，将不构成本协议以外之任何保证。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__十八、上海丙晟科技有限公司商标信息"><span /></a
      >十八、上海丙晟科技有限公司商标信息
    </h2>
    <p class="P5">
      <span class="T2"
        >丙晟科技网站（网址为http://www.beyonds.com）、移动应用名称以及其它商标、标志及产品、服务名称，均为丙晟科技之商标（以下简称"上海丙晟科技有限公司标记"）。未经丙晟科技事先书面同意，会员同意不将上海丙晟科技有限公司标记以任何方式展示或使用或作其它处理，或表示会员有权展示、使用或另行处理上海丙晟科技有限公司标记。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__十九、会员专属权利"><span /></a>十九、会员专属权利
    </h2>
    <p class="P5_borderStart">
      <span class="T2"
        >丙晟科技尊重他人知识产权，呼吁会员也要同样尊重知识产权。</span
      ><span class="T3"
        >丙晟科技之服务与资料是基于现状提供，而且丙晟科技明确地表示拒绝对于服务及相关资料或产品给予任何明示或暗示之保证，包括但不限于，得为商业使用或适合于特定目的之保证。丙晟科技对于因服务及相关资料或产品所生之任何直接、间接、附带的或因此而导致之衍生性损失概不负责。</span
      >
    </p>
    <p class="P5_borderEnd">
      <span class="T3"
        >如果会员对他人的知识产权造成了侵害，丙晟科技将依国家法律法规的规定，或在适当的情形下，将依其服务条款或其相关规范性规定，删除特定内容或以至终止会员对账户的使用。</span
      ><span class="T2"
        >丙晟科技尊重他人的任何权利（包括知识产权），同时也要求会员也尊重他人之权利。丙晟科技在适当情况下，得自行决定终止侵害或违反他人权利之使用者的账号。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__二十、一般条款"><span /></a>二十、一般条款
    </h2>
    <p class="P5_borderStart">
      <span class="T2"
        >1）本协议和免责声明构成会员与丙晟科技之全部协议，并规范会员对于服务之使用行为。在会员使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >2）本协议及会员与丙晟科技之关系，均受到中华人民共和国法律管辖。会员与丙晟科技就服务、本协议或其它有关事项发生的争议，应首先友好协商解决，协商不成时应提请任何一方均可向丙晟科技所在地有管辖权的人民法院提起诉讼；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >3）丙晟科技未行使或执行本协议任何权利或规定，不构成对前述权利或权利之放弃；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >4）倘本协议之任何规定因与中华人民共和国法律抵触而无效，会员依然同意应依照法律，努力使该规定所反映之当事人意向具备效力，且本协议其它规定仍应具有完整的效力及效果；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >5）本协议之标题仅供方便而设，不具任何法律或契约效果；</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >6)只要会员接受了丙晟科技服务，就代表会员接受任何以上所有协议。</span
      >
    </p>
    <p class="P5_borderEnd">
      <span class="T2">7）丙晟科技对本协议享有最终解释权。</span>
    </p>
    <h2 class="Heading_20_2">
      <a id="a__二十一、个人信息、通知及商务信息"><span /></a
      >二十一、个人信息、通知及商务信息
    </h2>
    <p class="P5_borderStart">
      <span class="T2"
        >在本协议项下，会员允许丙晟科技基于向会员持续提供更优质服务、提升服务体验、广告、市场营销等目的使用会员所提供的个人信息（包括但不限于账户信息、设备信息、位置信息、手机号、车辆车牌号、以及前述信息的关联方式等），同意并授权丙晟科技基于前述目的，在法律法规允许的范围内，将会员的前述个人信息共享与丙晟科技所提供服务相关的第三方或实际向会员提供服务的商户或其他服务提供方使用。但丙晟科技只会出于合法、正当、必要、特定、明确的目的与该等第三方共享您的个人信息，且只会共享提供服务所必要的个人信息。这些第三方无权将共享的个人信息用于其他用途。</span
      >
    </p>
    <p class="P5">
      <span class="T2"
        >会员同意并授权丙晟科技以及与其所提供服务相关的第三方基于向会员持续提供更优质服务之目的，向会员送达各类广告、通知等信息，包含并不限于：</span
      >
    </p>
    <p class="P5"><span class="T2">1）通知、公示、公告等；</span></p>
    <p class="P5"><span class="T2">2）站内信、客户端推送的消息等；</span></p>
    <p class="P5_borderEnd">
      <span class="T2"
        >3）根据您预留于丙晟科技网站（网址为http://www.beyonds.com）或丙晟科技任何服务平台（载体）的联系方式发出的电子邮件、短信、彩信、微信、函件、APP信息推送等。丙晟科技所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达会员。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__二十二、协议生效"><span /></a>二十二、协议生效
    </h2>
    <p class="P5">
      <span class="T2"
        >本协议自会员接受后生效，自会员取消服务时终止。本协议一经生效即对丙晟科技及会员具有约束力。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__二十三、其他规定"><span /></a>二十三、其他规定
    </h2>
    <p class="P5_borderStart">
      <span class="T2"
        >若本协议中的任何条款存在理解分歧，均应以丙晟科技作出的解释为准。</span
      >
    </p>
    <p class="P5_borderEnd">
      <span class="T2"
        >如本协议中的任何内容无论因何种原因完全或部分无效或不具有执行力，本协议的其余内容仍应有效并且对协议各方有约束力。</span
      >
    </p>
    <p class="Standard"></p>
    <h1 class="Heading_20_1">
      <a id="a__万达广场鸿蒙原子化服务隐私政策"><span /></a
      ><span class="T7">万达广场鸿蒙原子化服务隐私政策</span>
    </h1>
    <h2 class="Heading_20_2">
      <a id="a__引言"><span /></a><span class="T7">引言 </span>
    </h2>
    <p class="Standard">
      <span class="T5"
        >上海丙晟科技有限公司（“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《万达广场鸿蒙原子化服务隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、存储、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。需要特别说明的是，本隐私政策不适用于其他第三方向您提供的服务，第三方向您提供的服务适用其向您另行说明的隐私政策。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >本隐私政策与您所使用的万达广场鸿蒙原子化服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本隐私政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。对本政策中与您的权益存在重大关系的条款和个人敏感信息，我们将采用粗体字进行标注以提示您注意。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策（含更新版本）内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。本隐私政策适用于我们的平台(指万达广场鸿蒙原子化服务)。</span
      >
    </p>
    <h2 class="Heading_20_2">
      <a id="a__摘要"><span /></a><span class="T7">摘要</span>
    </h2>
    <p class="P2">
      <span class="T5"
        >一、我们的产品与/或服务包括一些核心功能，这些功能包含了实现领券中心、专题活动展示等所必须的功能，如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。我们的产品与/或服务的附加功能中也可能会收集和使用您的个人信息，前述功能可能需要您在您的设备中向我们开启您的定位、相机、相册权限。关于我们收集与使用您的信息请详见本政策正文“一、我们如何收集和使用您的个人信息”部分。</span
      >
    </p>
    <p class="P2">
      <span class="T5"
        >二、我们可能会向关联方、合作伙伴及第三方（包括商品或技术服务的供应商、第三方商家、第三方SDK）共享您的个人信息。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >三、我们会采取一切合理可行的措施保护您的个人信息，将收集的用户个人信息存储于中国境内，并仅在为实现目的所必需的时间内保留您的个人信息。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >四、您可实现对于您个人信息访问、更正、删除、获取个人信息副本、撤回同意、注销账户的权利，详见本隐私政策“五、您如何管理您的个人信息”部分。您也可以联系客服（400-950-6677）实现前述权利，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >五、若您是18周岁以下的未成年人，在使用我们的产品或服务前，应事先取得您监护人的同意。如果有事实证明未成年人并未取得监护人同意的情况下注册使用了我们的产品或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。对于可能涉及的不满14周岁的儿童个人信息，我们会采取更多措施予以保障。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >六、关于本隐私政策的更新，我们会通过在万达广场鸿蒙原子化服务发出更新版本并在生效前通过公告或以其他适当方式提醒您相关内容的更新。对于重大变更，我们还会提供更为显著的通知（我们会通过浏览页面做特别提示等方式，说明隐私政策的具体变更内容），并再次征得您的同意。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >七、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，您可拨打我们的客服电话（400-950-6677）或通过以下联系方式联系我们的个人信息保护相关负责人，我们将在十五天内回复：（一）发送邮件至service@beyonds.com；（二）邮寄信件至上海市静安区灵石路718号A5幢101室
        个人信息保护专员（收）。</span
      >
    </p>
    <p class="P3" />
    <h2 class="Heading_20_2">
      <a id="a__目录"><span /></a><span class="T7">目录 </span>
    </h2>
    <p class="Standard">
      <span class="T5">一、 我们如何收集和使用您的个人信息</span
      ><span class="T2"><br /></span
      ><span class="T5">二、 我们如何共享、转让、公开披露您的个人信息</span
      ><span class="T2"><br /></span
      ><span class="T5">三、 我们如何使用localStorage和同类技术</span
      ><span class="T2"><br /></span
      ><span class="T5">四、 我们如何保护和保存您的个人信息</span
      ><span class="T2"><br /></span
      ><span class="T5">五、 您如何管理您的个人信息</span
      ><span class="T2"><br /></span
      ><span class="T5">六、 未成年人的个人信息保护</span
      ><span class="T2"><br /></span><span class="T5">七、 修订和更新</span
      ><span class="T2"><br /></span><span class="T5">八、 如何联系我们</span>
    </p>
    <p class="P6" />
    <h3 class="Heading_20_3">
      <a id="a__一、我们如何收集和使用您的个人信息"><span /></a
      ><span class="T7">一、我们如何收集和使用您的个人信息</span>
    </h3>
    <div class="Standard">
      <span class="T5"
        >个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</span
      ><span class="T2"><br /></span
      ><span class="T4"
        >个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。<br />我们仅会出于以下目的，收集和使用您的个人信息：</span
      ><span class="T2"><br /></span
      ><span class="T5">（一）您须授权我们收集和使用您个人信息的情形</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们的产品与/或服务包括一些核心功能，这些功能包含了实现领券、专题活动查看所必须的功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：</span
      ><span class="T2"><br /></span><span class="T5">1、</span
      ><span class="T5">主要功能及服务</span><span class="T2"><br /></span
      ><span class="T5">（1）用户注册</span><span class="T2"><br /></span
      ><span class="T5"
        >当您注册/登录万达广场鸿蒙原子化服务时，我们会通过授权的方式收集您的</span
      ><span class="T4">昵称、头像、手机号码</span
      ><span class="T5"
        >。收集这些信息是为了帮助您完成万达广场鸿蒙原子化服务的账号注册，并在后续使用服务过程中保障您的帐号安全。收集手机号码为了作为用户注册的唯一标识，用作后续登录的账号凭证。拒绝提供该信息会使您无法使用万达广场鸿蒙原子化服务需要登录后才能操作的功能（如领券等），但不影响您正常使用浏览功能。</span
      ><span class="T2"><br /></span
      ><span class="T5">（2）信息展示和搜索服务</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >当您使用万达广场鸿蒙原子化服务的信息展示和搜索服务时，我们可能会收集您使用我们的</span
      ><span class="T4"
        >产品与/或服务的设备信息（包括设备品牌、设备型号、操作系统及版本、屏幕分辨率、微信设置的语言）</span
      ><span class="T5"
        >来为您提供商品或服务信息展示的最优方式。您也可以通过搜索来精准地找到您所需要的商品或服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的商品或服务。请您注意，您的搜索关键词信息无法单独识别您的身份，不属于您的个人信息，您认可并同意我们以任何目的对其进行使用；只有当您的搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。</span
      ><span class="T2"><br /></span
      ><span class="T5">（3）发送与您使用我们的产品和/或服务相关的信息</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >在您注册成为我们的用户后，即使您拒绝接收我们发送的商业推广信息，我们仍可能会使用您的</span
      ><span class="T4">手机号码</span
      ><span class="T5"
        >向您发送与我们的产品和/或服务相关的并会影响您权益的信息，例如产品信息或升级、产品召回的重要信息。</span
      ><span class="T2"><br /></span
      ><span class="T5">2、保障交易安全所必须的功能</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >为提高您使用我们的产品与/或服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过收集您的</span
      ><span class="T4"
        >手机号、昵称、头像、IP、设备信息、浏览信息、订单信息</span
      ><span class="T5"
        >来判断您的账号风险；我们也会收集您的设备信息对于万达广场鸿蒙原子化服务的系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。</span
      >
    </div>
    <p class="P6" />
    <p class="Standard">
      <span class="T5"
        >（二）您可选择是否授权我们收集和使用您的个人信息的情形</span
      >
    </p>
    <p class="Standard">
      <span class="T5"
        >1、为使您消费、获取资讯更便捷或更有乐趣，从而提升您在万达广场鸿蒙原子化的用户体验，我们的以下附加功能中可能会收集和使用您的个人信息。这些附加功能包括：</span
      ><span class="T2"><br /></span
      ><span class="T5">（1）基于位置信息的个性化推荐功能：我们会收集您的</span
      ><span class="T4">位置信息</span
      ><span class="T5"
        >（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点，自动为您推荐您所在区域可以领取的卡券或者专题活动，向您推荐离您最近的可选广场。当您拒绝提供位置信息时，仍可以继续使用其他功能。您也可以通过手动选择，切换到您需要的广场。</span
      ><span class="T2"><br /></span><span class="T5">（2）推广信息</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >为了向您发送您可能感兴趣的商品或者服务信息，您授权我们向您的</span
      ><span class="T4">手机号码</span
      ><span class="T5"
        >发送与我们的产品或服务相关信息，如您不再希望接收相关短信，请根据信息的提示操作退订。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（3）基于其他设备信息的附加功能：为了提供更好的产品和/或服务并改善用户体验，我们会收集</span
      ><span class="T4"
        >设备属性信息（包括您的硬件型号、操作系统版本、设备配置）</span
      ><span class="T5"
        >。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将您的设备信息或手机号码与您的万达广场鸿蒙原子化服务的帐户相关联。</span
      ><span class="T2"><br /></span
      ><span class="T5">2、上述功能可能需要您在您的设备中向我们开启您的</span
      ><span class="T4">定位、相册、相机权限</span
      ><span class="T5">，以实现这些功能所涉及的信息的收集和使用：</span
      ><span class="T2"><br /></span><span class="T5">（1）定位权限</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >为了自动为您推荐您所在区域可以领取的卡券或服务，向您推荐离您最近的可选广场，我们会调用您的</span
      ><span class="T4">定位权限</span><span class="T5">。</span
      ><span class="T2"><br /></span><span class="T5">（2）相册权限</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >您在使用扫一扫功能扫描设备相册中的描条码/二维码时，我们会调用您的</span
      ><span class="T4">相册权限</span><span class="T5">。</span
      ><span class="T2"><br /></span><span class="T5">（3）相机权限</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >您在使用扫一扫功能扫描描条码/二维码时，我们会调用您的</span
      ><span class="T4">相机权限</span><span class="T5">。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >为了便于您使用，在您使用鸿蒙原子化服务的过程中我们会询问您是否同意开启上述权限。您可以在【为手机-设置-顶部华为账号-隐私中心-控制对您账号的访问】中逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭（我们会指引您在您的设备系统中完成设置）。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</span
      ><span class="T2"><br /><br /></span
      ><span class="T5"
        >（三）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</span
      ><span class="T2"><br /></span
      ><span class="T5">1、与个人信息控制者履行法律法规规定的义务相关的；</span
      ><span class="T2"><br /></span
      ><span class="T5">2、与国家安全、国防安全直接相关的；</span
      ><span class="T2"><br /></span
      ><span class="T5">3、与公共安全、公共卫生、重大公共利益直接相关的；</span
      ><span class="T2"><br /></span
      ><span class="T5">4、与犯罪侦查、起诉、审判和判决执行等直接相关的；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >5、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又难以或及时得到本人同意的；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >6、所涉及的个人信息是个人信息主体自行向社会公众公开的；</span
      ><span class="T2"><br /></span
      ><span class="T5">7、根据个人信息主体要求签订和履行合同所必需的；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >8、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >9、维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。</span
      ><span class="T2"><br /><br /></span
      ><span class="T5"
        >（四）我们从第三方获得您个人信息的情形（个人信息的间接获取）</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们可能从第三方获取您授权共享的账户信息（头像、昵称等），并在您同意本隐私政策后将您的第三方账户与您的万达广场鸿蒙原子化服务账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。我们承诺，我们从第三方间接获取您的个人信息的数量为实现万达广场鸿蒙原子化服务产品业务功能所必须的最少数量。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们承诺，我们将了解并审慎注意，第三方已获得您的个人信息处理的授权同意范围，包括使用目的，您是否授权同意转让、共享、公开披露等。我们开展业务所需进行的个人信息处理活动超出该授权同意范围的，将在获取您的个人信息后的合理期限内或处理您的个人信息前，征得您的明示同意。</span
      ><span class="T2"><br /><br /></span
      ><span class="T5">（五）我们在您使用产品及服务过程中收集的信息</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们会收集关于您使用我们产品或服务以及使用方式的信息，这些信息包括：</span
      ><span class="T2"><br /></span
      ><span class="T5">设备信息：我们会接收并记录您所使用的</span
      ><span class="T4"
        >设备相关信息（设备型号、操作系统版本、设备设置、设备环境等软硬件特征信息）</span
      ><span class="T5">。</span><span class="T2"><br /></span
      ><span class="T5"
        >位置信息：我们会根据您在使用中授予的具体权限，接收并</span
      ><span class="T4">记录设备所在位置相关信息（IP地址）</span
      ><span class="T5"
        >。如果您在使用过程中拒绝授予我们相应权限的，我们并不会记录您的位置相关信息。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >服务日志信息：当您使用我们小程序提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。包括</span
      ><span class="T4"
        >搜索查询内容、IP地址、使用的语言、访问日期和时间及您访问的记录</span
      ><span class="T5">等。</span><span class="T2"><br /></span
      ><span class="T5"
        >请您理解，单独的设备信息、日志信息等是无法识别特定自然人身份的信息，其不属于个人信息。除非将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，那么在结合使用期间，这类非个人信息将被视为个人信息，我们会将该类个人信息做匿名化、去标识化处理（取得您的授权或法律法规另有规定的情况除外）。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >当您与我们联系时，为验证您的身份，帮助您解决问题，我们可能会记录您与我们的对话并收集其他为解决问题所需的必要信息。</span
      ><span class="T2"><br /><br /></span
      ><span class="T5">（六）您个人信息使用的规则</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >1、我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >2、请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息或对您的个人信息进行匿名化处理。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >3、我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >4、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >5、当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。</span
      >
    </p>
    <p class="P6" />
    <h3 class="Heading_20_3">
      <a id="a__二、我们如何共享、转让、公开披露您的个人信息"><span /></a
      ><span class="T7">二、我们如何共享、转让、公开披露您的个人信息</span>
    </h3>
    <h4 class="Heading_20_4">
      <a id="a__（一）共享"><span /></a><span class="T7">（一）共享</span>
    </h4>
    <p class="Standard">
      <span class="T5"
        >1、我们不会与任何公司、组织和个人共享您的个人信息，但以下情形除外：</span
      ><span class="T2"><br /></span
      ><span class="T5">（1）事先获得您明确的同意或授权；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；</span
      ><span class="T2"><br /></span><span class="T5">2、</span
      ><span class="T4"
        >由于万达广场鸿蒙原子化服务为万达广场商业生态的一部分，您授权并同意我们整体将“一、我们如何收集和使用您的个人信息”部分所涉的您的全部个人信息向万达商业管理集团有限公司共享</span
      ><span class="T5">。</span><span class="T2"><br /></span
      ><span class="T5"
        >3、您授权并同意我们将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >4、我们可能会向合作伙伴及第三方共享您的个人信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。我们的合作伙伴包括以下类型：</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（1）商品或技术服务的供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。这些支持包括为我们的物流配送服务、停车服务、影院订票服务支付服务、数据处理。我们共享这些信息的目的是可以实现我们产品与/或服务的相关功能：</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（2）由于万达广场鸿蒙原子化服务是基于鸿蒙环境搭建，为了完成支付、分享、登录，我们可能会向深圳市华为技术有限公司共享您的</span
      ><span class="T4">设备信息、位置信息、昵称、头像、手机号码</span
      ><span class="T5">。</span><span class="T2"><br /></span
      ><span class="T5"
        >5、我们已知晓对外共享、转让、公开披露个人信息所承担的相应法律责任。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。关于我们接入的合作伙伴等第三方的SDK目录如下：</span
      ><span class="T2"><br /><br /></span
      ><span class="T5"
        >SDK名称 所属机构 用途 SDK收集的个人信息类型 SDK的隐私政策/官网链接
        备注</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >数美风控 北京数美时代科技有限公司 风控服务
        手机号、昵称、头像、IP、设备信息
        https://www.ishumei.com/legal/cn/privacy.html</span
      ><span class="T2"><br /><br /></span
      ><span class="T5"
        >6、为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护万达广场鸿蒙原子化服务、您或其他万达广场鸿蒙原子化服务客户的权利及其财产或安全，包括为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过，这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。</span
      >
    </p>
    <p class="P6" />
    <h4 class="Heading_20_4">
      <a id="a__（二）转让"><span /></a><span class="T7">（二）转让</span>
    </h4>
    <p class="Standard">
      <span class="T5"
        >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span
      ><span class="T2"><br /></span
      ><span class="T5">1、事先获得您明确的同意或授权；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >3、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >4、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</span
      >
    </p>
    <p class="P6" />
    <h4 class="Heading_20_4">
      <a id="a__（三）公开披露"><span /></a
      ><span class="T7">（三）公开披露</span>
    </h4>
    <p class="Standard">
      <span class="T5"
        >我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。</span
      >
    </p>
    <p class="P6" />
    <h4 class="Heading_20_4">
      <a id="a__（四）共享、转让、公开披露个人信息时事先征得授权同意的例外"
        ><span /></a
      ><span class="T7"
        >（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</span
      >
    </h4>
    <p class="Standard">
      <span class="T5"
        >以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >1、根据法律法规的规定或行政、司法机构、国家部门等有权机关的要求依法提供的；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >2、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</span
      ><span class="T2"><br /></span
      ><span class="T5">3、您自行向社会公众公开的个人信息；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >4、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >5、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</span
      ><span class="T2"><br /></span
      ><span class="T5">6、基于符合法律法规的社会公共利益的需要。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span
      >
    </p>
    <h3 class="Heading_20_3">
      <a id="a__三、我们如何使用local_Storage和同类技术"><span /></a
      ><span class="T7">三、我们如何使用local Storage和同类技术</span>
    </h3>
    <h4 class="Heading_20_4">
      <a id="a__（一）Local_Storage的使用"><span /></a
      ><span class="T7">（一）Local Storage的使用</span>
    </h4>
    <p class="Standard">
      <span class="T5"
        >1、为确保万达广场鸿蒙原子化服务正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的移动设备上存储名为Local
        Storage小数据文件。Local
        Storage通常包含标识符以及对应的字符串。借助于Local
        Storage，应用能够存储您的偏好或购物车内的商品及服务数据。我们使用Local
        Storage是为了简化您重复登录的步骤、存储您的购物偏好或您购物车中的商品及服务数据进而为您提供购物的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >2、我们不会将Local
        Storage中的数据用于本隐私政策所述目的之外的任何用途。在您删除【万达广场鸿蒙原子化服务】应用时，您之前所记录的相应信息也均会被删除。</span
      >
    </p>
    <p class="P6" />
    <h3 class="Heading_20_3">
      <a id="a__四、我们如何保护和保存您的个人信息"><span /></a
      ><span class="T7">四、我们如何保护和保存您的个人信息</span>
    </h3>
    <h4 class="Heading_20_4">
      <a id="a__（一）我们保护您个人信息的技术与措施"><span /></a
      ><span class="T7">（一）我们保护您个人信息的技术与措施</span>
    </h4>
    <p class="Standard">
      <span class="T5"
        >我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：</span
      ><span class="T2"><br /></span><span class="T5">1、数据安全技术措施</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >万达广场鸿蒙原子化服务的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >在个人信息使用时，我们会采用包括内容替换、SHA256在内多种数据脱敏技术增强个人信息在使用中安全性。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们采用代码安全自动检查、数据访问日志分析技术进行个人信息安全审计。</span
      ><span class="T2"><br /></span
      ><span class="T5">2、我们为保护个人信息采取的其他安全措施</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们通过建立数据分类分级制度、数据安全管理规范来管理规范个人信息的存储和使用。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</span
      ><span class="T2"><br /></span
      ><span class="T5">我们建立数据安全管理组织来推进和保障个人信息安全。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们存储您个人数据的底层云技术取得了数据中心联盟颁发的“可信云”认证。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >3、我们仅允许有必要知晓这些信息的万达广场所属公司（包含其管理公司及隶属集团）及我们关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与万达广场鸿蒙原子化服务的合作关系。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >4、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >5、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</span
      ><span class="T2"><br /></span><span class="T5">6、安全事件处置</span>
    </p>
    <p class="Standard">
      <span class="T5"
        >在通过【万达广场鸿蒙原子化服务】与第三方进行网上商品或服务的交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。</span
      >
    </p>
    <p class="Standard">
      <span class="T5"
        >在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span
      >
    </p>
    <p class="Standard">
      <span class="T5"
        >7、如果您对我们的个人信息保护有任何疑问，可通过本隐私政策最下方约定的联系方式联系我们。如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本隐私政策最下方【如何联系我们】约定的联系方式联络我们，以便我们采取相应措施。</span
      >
    </p>
    <p class="P6" />
    <h4 class="Heading_20_4">
      <a id="a__（二）您个人信息的保存"><span /></a
      ><span class="T7">（二）您个人信息的保存</span>
    </h4>
    <p class="Standard">
      <span class="T5">1、信息存储的地点</span><span class="T2"><br /></span
      ><span class="T5"
        >我们将严格依照国家法律法规的相关规定，使用腾讯云服务能力，将收集的用户个人信息存储于中国境内。</span
      ><span class="T2"><br /></span><span class="T5">2、信息存储的期限</span
      ><span class="T2"><br /></span
      ><span class="T4"
        >一般而言，我们仅在为实现目的所必需的最短时间内保留您的个人信息</span
      ><span class="T5">，例如：</span><span class="T2"><br /></span
      ><span class="T5"
        >手机号码、用户头像和昵称：若您需要使用万达广场鸿蒙原子化服务服务，我们需要一直保存您的手机号码、用户头像和昵称，以保证您正常使用该服务，当您注销万达广场鸿蒙原子化服务帐户后，我们将删除相应的信息。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >订单信息：当您使用万达广场鸿蒙原子化服务购买、兑换商品时，自交易完成后我们至少保留您的交易信息三年。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >收货地址：我们会在服务端保存您的收货地址信息，您可以随时新增、更改和删除该信息。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理（所谓“匿名化处理”，是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息）。</span
      >
    </p>
    <p class="P6" />
    <h3 class="Heading_20_3">
      <a id="a__五、您如何管理您的个人信息"><span /></a
      ><span class="T7">五、您如何管理您的个人信息</span>
    </h3>
    <p class="Standard">
      <span class="T5"
        >我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</span
      >
    </p>
    <h4 class="Heading_20_4">
      <a id="a__（一）访问和更正您的个人信息"><span /></a
      ><span class="T7">（一）访问和更正您的个人信息</span>
    </h4>
    <p class="Standard">
      <span class="T5">（1）您的用户信息</span><span class="T2"><br /></span
      ><span class="T5"
        >修改用户信息具体路径为：首页设置-用户信息-新建头像昵称；</span
      ><span class="T2"><br /></span><span class="T5">（2）您的卡券</span
      ><span class="T2"><br /></span
      ><span class="T5">您可以通过访问端 “我的-优惠券”查看您的卡券。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（3）对于您在使用我们的产品或服务过程中产生的其他个人信息需要访问或更正的需求，请随时联系我们。我们会根据本隐私政策所列明的方式响应您的请求。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（4）您无法访问和更正的个人信息：除上述列明的信息外，您的部分个人信息我们还无法为您提供访问和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息、您使用扩展功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您无法访问和更正，但您可联系我们进行删除或做匿名化处理。</span
      >
    </p>
    <h4 class="Heading_20_4">
      <a id="a__（二）改变您授权同意的范围或撤回您的授权"><span /></a
      ><span class="T7">（二）改变您授权同意的范围或撤回您的授权</span>
    </h4>
    <p class="Standard">
      <span class="T5"
        >您可以通过关闭设备功能，在万达广场鸿蒙原子化服务中进行“设置”等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span
      >
    </p>
    <h4 class="Heading_20_4">
      <a id="a__（三）注销您的个人账户"><span /></a
      ><span class="T7">（三）注销您的个人账户</span>
    </h4>
    <p class="Standard">
      <span class="T5"
        >您可以通过拨打我们的客服电话（400-950-6677）进行个人账户的注销，若我们决定响应您的注销请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中注销账户后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >我们在此善意地提醒您，您注销账户的行为会给您的售后维权带来诸多不便，且注销万达广场鸿蒙原子化服务账户后，我们会将您的个人信息在万达广场鸿蒙原子化服务系统中去除，使其保持不可被检索、访问的状态，或对其进行匿名化处理。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（1）万达广场鸿蒙原子化服务账户一旦被注销将不可恢复，请您保存好订单商品和服务的交易凭证、票据等资料，否则您有可能无法享受售后服务。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（2）注销万达广场鸿蒙原子化服务账户，您将无法再使用本万达广场鸿蒙原子化服务账户，也将无法找回您万达广场鸿蒙原子化服务账户中及与账户相关的任何内容或信息，包括但不限于：</span
      ><span class="T2"><br /></span><span class="T6">①</span
      ><span class="T5"> 您将无法登录、使用本万达广场鸿蒙原子化服务账户；</span
      ><span class="T2"><br /></span><span class="T6">②</span
      ><span class="T5">
        本万达广场鸿蒙原子化服务账户的个人资料和历史信息（包括但不限于用户名、头像、交易记录、关注信息等）都将无法找回；</span
      ><span class="T2"><br /></span><span class="T6">③</span
      ><span class="T5">
        您通过万达广场鸿蒙原子化服务账户使用、授权登录或绑定万达广场鸿蒙原子化服务账户后使用的万达广场鸿蒙原子化服务相关或第三方的其他服务的所有记录将无法找回。您将无法再登录、使用前述服务，您曾获得的积分、优惠券、资格、订单、等各项权益及其他卡券等视为您自行放弃，将无法继续使用。您理解并同意，万达广场鸿蒙原子化服务无法协助您重新恢复前述服务。请您在提交注销申请前，务必先了解您须解绑的其他相关账户信息，具体可与我们的客服联系。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（3）注销万达广场鸿蒙原子化服务账户并不代表万达广场鸿蒙原子化服务账户注销前的账户行为和相关责任得到豁免或减轻。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >有下列情形之一的，我们有权决定暂不予注销您在万达广场鸿蒙原子化服务的账户信息而无需另行得到您的同意：</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（1）账户内有未完成的订单和服务，对万达广场鸿蒙原子化服务或第三方有影响的；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（2）在您申请万达广场鸿蒙原子化服务账户注销期间，如果您的万达广场鸿蒙原子化服务账户涉及争议或纠纷的，包括但不限于投诉、举报、诉讼、仲裁、国家有关机关调查等；</span
      ><span class="T2"><br /></span
      ><span class="T5">（3）其他法律法规规定的不得注销或删除的内容。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。符合以上注销条款后，将于15日内完成注销操作。</span
      >
    </p>
    <h4 class="Heading_20_4">
      <a
        id="a__（四）您同意我们向您发送促销信息，如果您不想再接受我们给您发送的促销信息，您随时可通过以下方式取消："
        ><span /></a
      ><span class="T7"
        >（四）您同意我们向您发送促销信息，如果您不想再接受我们给您发送的促销信息，您随时可通过以下方式取消：</span
      >
    </h4>
    <p class="Standard">
      <span class="T5"
        >（1）您可以根据商业推送短信内容提示，来取消我们给您发送的手机商业推送短信。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（2）您可以通过小程序“设置-消息订阅”设置是否接受我们通过“消息”推送给您的商品和促销信息。</span
      >
    </p>
    <h4 class="Heading_20_4">
      <a id="a__（五）响应您的请求"><span /></a
      ><span class="T7">（五）响应您的请求</span>
    </h4>
    <p class="Standard">
      <span class="T5"
        >如果您无法通过上述方式访问、更正您的个人信息，或您需要访问、更正您在使用我们产品与/或服务时所产生的其他个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以发送电子邮件至service@beyonds.com或通过本隐私政策中的其他方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或提供您的身份证明文件，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。在以下情形中，按照法律法规要求，我们将无法响应您的请求：</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（1）与个人信息控制者履行法律法规规定的义务相关的；</span
      ><span class="T2"><br /></span
      ><span class="T5">（2）与国家安全、国防安全有关的；</span
      ><span class="T2"><br /></span
      ><span class="T5">（3）与公共安全、公共卫生、重大公共利益有关的；</span
      ><span class="T2"><br /></span
      ><span class="T5">（4）与犯罪侦查、起诉和审判等有关的；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</span
      ><span class="T2"><br /></span
      ><span class="T5">（8）涉及商业秘密的。</span>
    </p>
    <p class="P6" />
    <h3 class="Heading_20_3">
      <a id="a__六、未成年人的个人信息保护"><span /></a
      ><span class="T7">六、未成年人的个人信息保护</span>
    </h3>
    <div class="Standard">
      <span class="T5"
        >1、我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品或服务前，应事先取得您监护人的同意。我们根据国家相关法律法规的规定保护未成年人的个人信息。如果有事实证明未成年人并未取得监护人同意的情况下注册使用了我们的产品或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >2、对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（1）对于收集到的儿童个人信息，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（2）当您作为监护人为被监护的儿童选择使用万达广场鸿蒙原子化服务相关服务时，我们可能需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。在具体服务中需要向您收集儿童个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。</span
      ><span class="T2"><br /></span><span class="T5">（3）</span
      ><span class="T4"
        >关于我们对儿童个人信息的收集、使用、存储、保护规则等，我们制定了专门的条款。如您是14岁以下儿童，您和您的监护人应仔细阅读</span
      ><span class="T4">《儿童个人信息保护规则》</span
      ><span class="T4"
        >，并确保在取得监护人对《儿童个人信息保护规则》的同意后，您才可在监护人的指导下使用我们的服务</span
      ><span class="T5">。</span><span class="T2"><br /></span>
    </div>
    <h3 class="Heading_20_3">
      <a id="a__七、修订和更新"><span /></a
      ><span class="T7">七、修订和更新</span>
    </h3>
    <p class="Standard">
      <span class="T5"
        >1、为给您提供更好的服务以及随着万达广场鸿蒙原子化服务业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在万达广场鸿蒙原子化服务上发出更新版本并在生效前通过公告或以其他适当方式提醒您相关内容的更新，也请您访问万达广场鸿蒙原子化服务以便及时了解最新的隐私政策。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >2、对于重大变更，我们还会提供更为显著的通知（我们会通过浏览页面做特别提示等方式，说明隐私政策的具体变更内容），并再次征得您的同意。</span
      ><span class="T2"><br /></span
      ><span class="T5">本隐私政策所指的重大变更包括：</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（3）个人信息共享、转让或公开披露的主要对象发生变化；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</span
      ><span class="T2"><br /></span
      ><span class="T5">（6）个人信息安全影响评估报告表明存在高风险时。</span
      ><span class="T2"><br /></span
      ><span class="T5">3、我们还会将本策略的旧版本存档，供您查阅。</span>
    </p>
    <h3 class="Heading_20_3">
      <a id="a__八、如何联系我们"><span /></a
      ><span class="T7">八、如何联系我们</span>
    </h3>
    <p class="Standard">
      <span class="T5"
        >1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过以下“产品运营者基本情况”中的联系方式联系我们。</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >2、一般情况下，我们将在十五天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：</span
      ><span class="T2"><br /></span
      ><span class="T5">（1）向被告所在地人民法院提起民事诉讼；</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >（2）向中央网信办举报（举报中心网址为：http://www.12377.cn，举报电话为：12377）。</span
      ><span class="T2"><br /></span
      ><span class="T5">3、产品运营者基本情况</span
      ><span class="T2"><br /></span
      ><span class="T5">产品名称：万达广场鸿蒙原子化服务</span
      ><span class="T2"><br /></span
      ><span class="T5">公司名称：上海丙晟科技有限公司</span
      ><span class="T2"><br /></span
      ><span class="T5">注册地址：上海市静安区灵石路718号A5幢101室</span
      ><span class="T2"><br /></span
      ><span class="T5">常用办公地址：上海市静安区灵石路718号A5幢101室</span
      ><span class="T2"><br /></span><span class="T5">电话：400-950-6677</span
      ><span class="T2"><br /></span
      ><span class="T5"
        >个人信息保护相关负责人联系方式：（一）发送邮件至service@beyonds.com；（二）邮寄信件至上海市静安区灵石路718号A5幢101室
        个人信息保护专员（收）</span
      >
    </p>
    <p class="Standard"></p>
  </div>
</template>

<script>
export default {
  name: 'User',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.user {
  width: 100%;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
}
td,
th {
  vertical-align: top;
  font-size: 12px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  clear: both;
}
ol,
ul {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
li span {
  clear: both;
  line-height: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}
span.footnodeNumber {
  padding-right: 1em;
}
span.annotation_style_by_filter {
  font-size: 95%;
  font-family: Arial;
  background-color: #fff000;
  margin: 0;
  border: 0;
  padding: 0;
}
span.heading_numbering {
  margin-right: 0.8rem;
}
* {
  margin: 0;
}
.P1 {
  font-size: 10.5px;
  margin-bottom: 0.1945px;
  margin-top: 0px;
  text-align: center !important;
  writing-mode: horizontal-tb;
  direction: ltr;
}
.P10 {
  font-size: 12px;
  margin-bottom: 0.1945px;
  margin-top: 0.1945px;
  text-align: left !important;
  writing-mode: horizontal-tb;
  direction: ltr;
  margin-left: 0.2957px;
  margin-right: 0px;
  text-indent: 0.0374px;
  color: #000000;
}
.P2 {
  font-size: 10.5px;
  margin-bottom: 0.1945px;
  margin-top: 0.1945px;
  text-align: left !important;
  writing-mode: horizontal-tb;
  direction: ltr;
  margin-left: 0px;
  margin-right: 0px;
  text-indent: 2em;
}
.P3 {
  font-size: 10.5px;
  margin-bottom: 0.1945px;
  margin-top: 0.1945px;
  text-align: left !important;
  writing-mode: horizontal-tb;
  direction: ltr;
  margin-left: 0px;
  margin-right: 0px;
  text-indent: 0.3335px;
}
.P4 {
  font-size: 10.5px;
  margin-bottom: 0.1945px;
  margin-top: 0.1945px;
  text-align: left !important;
  writing-mode: horizontal-tb;
  direction: ltr;
  margin-left: 0px;
  margin-right: 0px;
  text-indent: 0.3335px;
}
.P5 {
  font-size: 10.5px;
  text-align: left !important;
  writing-mode: horizontal-tb;
  direction: ltr;
  line-height: 22px;
  margin-top: 20px;
}
.P7 {
  font-size: 10.5px;
  margin-bottom: 0.1945px;
  margin-top: 0.1945px;
  text-align: left !important;
  writing-mode: horizontal-tb;
  direction: ltr;
}
.P8 {
  font-size: 12px;
  margin-bottom: 0.1945px;
  margin-top: 0.1945px;
  text-align: left !important;
  writing-mode: horizontal-tb;
  direction: ltr;
  color: #000000;
}
.P9 {
  font-size: 10.5px;
  margin-bottom: 0.1945px;
  margin-top: 0.1945px;
  text-align: left !important;
  writing-mode: horizontal-tb;
  direction: ltr;
  margin-left: 0px;
  margin-right: 0px;
  text-indent: 0.3937px;
}
.Standard {
  font-size: 10.5px;
  writing-mode: horizontal-tb;
  direction: ltr;
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: justify !important;
}
.T1 {
  color: #000000;
  font-size: 16px;
  font-weight: bold;
}
.T2 {
  color: #000000;
  font-size: 12px;
  font-weight: bold;
}
.T3 {
  color: #000000;
  font-size: 12px;
  font-weight: bold;
}
.T4 {
  color: #000000;
  font-size: 12px;
}
.T5 {
  color: #000000;
  font-size: 12px;
  text-indent: 2em;
}

p {
  line-height: 22px !important;
}

.Heading_20_1 {
  font-size: 22pt;
  margin-bottom: 0.2291px;
  margin-top: 0.2362px;
  text-align: justify !important;
  font-family: Calibri;
  writing-mode: horizontal-tb;
  direction: ltr;
  line-height: 241%;
  font-weight: bold;
}

.Heading_20_2 {
  font-size: 16pt;
  margin-bottom: 0.1807px;
  margin-top: 0.1807px;
  text-align: justify !important;
  font-family: Calibri Light;
  writing-mode: horizontal-tb;
  direction: ltr;
  line-height: 173%;
  font-weight: bold;
}

.Heading_20_3 {
  font-size: 16pt;
  margin-bottom: 0.1807px;
  margin-top: 0.1807px;
  text-align: justify !important;
  font-family: Calibri;
  writing-mode: horizontal-tb;
  direction: ltr;
  line-height: 173%;
  font-weight: bold;
}

.Heading_20_4 {
  font-size: 14pt;
  margin-bottom: 0.2016px;
  margin-top: 0.1945px;
  text-align: justify !important;
  font-family: Calibri Light;
  writing-mode: horizontal-tb;
  direction: ltr;
  line-height: 156%;
  font-weight: bold;
}

.P1 {
  font-size: 22pt;
  font-weight: bold;
  line-height: 241%;
  margin-bottom: 0.2291px;
  margin-top: 0.2362px;
  text-align: justify !important;
  font-family: Calibri;
  writing-mode: horizontal-tb;
  direction: ltr;
}

.P2 {
  font-size: 10.5pt;
  margin-bottom: 0px;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
  text-align: justify !important;
  text-indent: 0px;
  font-family: Calibri;
  writing-mode: horizontal-tb;
  direction: ltr;
}

.P3_borderStart {
  font-size: 9pt;
  margin-left: 0.25px;
  margin-right: 0px;
  margin-top: 0px;
  text-align: justify !important;
  text-indent: 0px;
  font-family: Helvetica Neue;
  writing-mode: horizontal-tb;
  direction: ltr;
  color: #606266;
  background-color: #ffffff;
  padding-bottom: 0px;
  border-bottom-style: none;
}

.P3 {
  font-size: 9pt;
  margin-left: 0.25px;
  margin-right: 0px;
  text-align: justify !important;
  text-indent: 0px;
  font-family: Helvetica Neue;
  writing-mode: horizontal-tb;
  direction: ltr;
  color: #606266;
  background-color: #ffffff;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-style: none;
  border-bottom-style: none;
}

.P3_borderEnd {
  font-size: 9pt;
  margin-bottom: 0px;
  margin-left: 0.25px;
  margin-right: 0px;
  text-align: justify !important;
  text-indent: 0px;
  font-family: Helvetica Neue;
  writing-mode: horizontal-tb;
  direction: ltr;
  color: #606266;
  background-color: #ffffff;
  padding-top: 0px;
  border-top-style: none;
}

.P4_borderStart {
  font-size: 9pt;
  margin-top: 0px;
  text-align: left !important;
  font-family: Helvetica Neue;
  writing-mode: horizontal-tb;
  direction: ltr;
  background-color: #ffffff;
  color: #606266;
  padding-bottom: 0px;
  border-bottom-style: none;
}

.P4 {
  font-size: 9pt;
  text-align: left !important;
  font-family: Helvetica Neue;
  writing-mode: horizontal-tb;
  direction: ltr;
  background-color: #ffffff;
  color: #606266;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-style: none;
  border-bottom-style: none;
}

.P4_borderEnd {
  font-size: 9pt;
  margin-bottom: 0px;
  text-align: left !important;
  font-family: Helvetica Neue;
  writing-mode: horizontal-tb;
  direction: ltr;
  background-color: #ffffff;
  color: #606266;
  padding-top: 0px;
  border-top-style: none;
}

.P5_borderStart {
  font-size: 12pt;
  margin-top: 0px;
  text-align: left !important;
  font-family: 宋体;
  writing-mode: horizontal-tb;
  direction: ltr;
  background-color: #ffffff;
  padding-bottom: 0px;
  border-bottom-style: none;
}

.P5 {
  font-size: 12pt;
  text-align: left !important;
  font-family: 宋体;
  writing-mode: horizontal-tb;
  direction: ltr;
  background-color: #ffffff;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-style: none;
  border-bottom-style: none;
}

.P5_borderEnd {
  font-size: 12pt;
  margin-bottom: 0px;
  text-align: left !important;
  font-family: 宋体;
  writing-mode: horizontal-tb;
  direction: ltr;
  background-color: #ffffff;
  padding-top: 0px;
  border-top-style: none;
}

.P6_borderStart {
  font-size: 9pt;
  margin-top: 0px;
  text-align: justify !important;
  font-family: Helvetica Neue;
  writing-mode: horizontal-tb;
  direction: ltr;
  color: #606266;
  background-color: #ffffff;
  padding-bottom: 0px;
  border-bottom-style: none;
}

.P6 {
  font-size: 9pt;
  text-align: justify !important;
  font-family: Helvetica Neue;
  writing-mode: horizontal-tb;
  direction: ltr;
  color: #606266;
  background-color: #ffffff;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-style: none;
  border-bottom-style: none;
}

.P6_borderEnd {
  font-size: 9pt;
  margin-bottom: 0px;
  text-align: justify !important;
  font-family: Helvetica Neue;
  writing-mode: horizontal-tb;
  direction: ltr;
  color: #606266;
  background-color: #ffffff;
  padding-top: 0px;
  border-top-style: none;
}

.Standard {
  line-height: 30px !important;

  span.T5 {
    line-height: 30px !important;
  }
}
</style>
